import React from 'react';

import { FlightControlSimulator, pilotTelemetryStore, mapStaticElementsStore } from '../../simulator';
import AntMediaVideo from '../components/AntMediaVideo';
import DroneMapPanel from '../components/DroneMapPanel';
import FlightMetricsPanel from '../components/FlightMetricsPanel';

export function getPanelContent(id: string): React.ReactNode {
  const store = pilotTelemetryStore;
  switch (id) {
    case 'video':
      return (
        <AntMediaVideo
          streamId='VImnlKEu9X3w8P6C4250675906580087'
          websocketUrl='wss://sifly.stockmasters.com/WebRTCAppEE/websocket'
        />
      );
    case 'map':
      return (
        <>
          <DroneMapPanel
            dronePosition={{ latitude: store.telemetry.lat, longitude: store.telemetry.lon }}
            droneHeading={store.telemetry.heading}
            initialMapCenterPosition={{ latitude: store.telemetry.lat, longitude: store.telemetry.lon }}
            dronePath={store.path.map((p) => ({ latitude: p.lat, longitude: p.lon }))}
            geoFences={mapStaticElementsStore.mapStaticElements.geoFences}
          />
          <div className='p-2'>
            <button type='button' className='w-full bg-red-600 text-white py-1'>
              Declare Emergency
            </button>
          </div>
        </>
      );
    case 'controls':
      return (
        <FlightMetricsPanel
          timeRemainingSec={600}
          timeToHomeSec={120}
          timeSinceTakeoffSec={300}
          distanceFromHomeM={250}
          batteryRemaining={0.75}
          windSpeedMps={5}
          windDirectionDeg={180}
          headingDeg={90}
          pitchDeg={2}
          rollDeg={-1}
          gpsReception='Good'
          gpsFix='3D'
        />
      );
    case 'simulator':
      return <FlightControlSimulator store={store} />;
    default:
      return null;
  }
}
